import type { QuoteDocument, QuoteFile } from 'paintscout'

import reduce from 'lodash/reduce'

export function updateFiles(args: {
  quote: QuoteDocument
  files: QuoteFile[]
  removedFiles?: string[]
}): QuoteDocument {
  const { files, removedFiles = [] } = args

  const quote = args.quote.images ? removeLegacyImages(args) : args.quote

  return {
    ...quote,
    files: files.reduce(
      (allFiles, file) => {
        const { key } = file
        if (removedFiles.includes(file.key)) {
          return allFiles
        }
        return {
          ...allFiles,
          [key]: {
            ...file,
            key
          }
        }
      },
      { ...quote.files }
    )
  }
}

// Removes the image from quote.images if it's now being saved as a file
function removeLegacyImages(args: { quote: QuoteDocument; files: QuoteFile[] }) {
  const { quote, files } = args

  const legacyImages = files.filter((file) => !!quote.images[file.key])

  if (legacyImages.length > 0) {
    const images = reduce(
      quote.images,
      (quoteImages, image) => {
        if (files.findIndex((file) => file.key === image.key) === -1) {
          return {
            ...quoteImages,
            [image.key]: image
          }
        }

        return quoteImages
      },
      {}
    )

    return {
      ...quote,
      images
    }
  }

  return quote
}
